// extracted by mini-css-extract-plugin
export default {"review-card":"ReviewCard_review-card__C6FDd","title":"ReviewCard_title__ViaTs"};